import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mpl-tenant");
  if (t) cfg.headers["X-MPL-Tenant"] = t;
  return cfg;
});

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/register"];
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && !original._retry && !NO_RETRY.some((p) => url.startsWith(p))) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  },
);

export function errMsg(e, fallback = "Une erreur est survenue. Réessayez.") {
  if (!e?.response) return "Connexion impossible. Vérifiez votre réseau.";
  const d = e.response.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Certaines informations sont invalides. Vérifiez le formulaire.";
  return fallback;
}
